<template>
  <v-alert
    v-if="isClassMode"
    color="primary lighten-6"
    prominent
    class="px-8"
    rounded="xl"
  >
    <v-row align="center">
      <v-col class="grow">
        {{ $t('CLASS_MODE.ENABLED') }}<br />
        <strong>{{ $t('CLASS_MODE.ROOM') }} {{ $store.state.classMode.session }}</strong>
      </v-col>
      <v-col class="shrink">
        <v-btn text icon @click="disableClassModeModal = true">
          <v-icon>logout</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <ClassModeDisableModal v-model="disableClassModeModal" />
  </v-alert>
</template>

<script>
import ClassModeDisableModal from '@/components/profile/ClassModeDisableModal.vue';

export default {
  name: 'ClassModeAlert',
  components: {
    ClassModeDisableModal,
  },
  data: () => ({
    disableClassModeModal: false,
  }),
};
</script>
